import React from 'react';
import { formatDateHebrewWithYear } from '../../../utils/dateUtils';

export const CancelConfirmationModal = ({ isOpen, appointment, onConfirm, onCancel, isLoading }) => {
  if (!isOpen || !appointment) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 shadow-2xl">
        <h3 className="text-lg font-bold text-gray-900 mb-3 text-center">
          ביטול תור
        </h3>
        <div className="text-center mb-4">
          <p className="text-gray-600 mb-2">
            האם אתה בטוח שברצונך לבטל את התור?
          </p>
          <div className="bg-gray-50 rounded-lg p-3 text-sm">
            <div className="font-medium text-gray-900">{appointment.service_name}</div>
            <div className="text-gray-600">
              {formatDateHebrewWithYear(appointment.date)} בשעה {appointment.time}
            </div>
          </div>
        </div>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 bg-gray-100 text-gray-700 py-2 px-4 rounded-lg font-medium hover:bg-gray-200 transition-colors"
          >
            ביטול
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 bg-red-500 text-white py-2 px-4 rounded-lg font-medium hover:bg-red-600 transition-colors disabled:opacity-50"
          >
            {isLoading ? 'מבטל...' : 'אשר ביטול'}
          </button>
        </div>
      </div>
    </div>
  );
};
